import { cn } from '@/utils/cn';
import type React from 'react';

interface RedirectLinkProps {
  to: string;
  children: React.ReactNode;
  replace?: boolean;
  className?: string;
  [key: string]: any;
}

const RedirectLink: React.FC<RedirectLinkProps> = ({
  to,
  children,
  replace = false,
  className,
  ...props
}: RedirectLinkProps) => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();

    if (replace) {
      window?.history?.replaceState({}, '', to);
    } else {
      window?.history?.pushState({}, '', to);
    }

    window?.dispatchEvent?.(new PopStateEvent('popstate'));
  };

  return (
    <div
      // biome-ignore lint/a11y/useSemanticElements: SSR friendly link
      role="link"
      tabIndex={0}
      aria-label={`Navigate to ${to}`}
      className={cn(className, 'cursor-pointer')}
      onClick={handleClick}
      onKeyDown={(e) => e.key === 'Enter' && handleClick(e as any)}
      itemScope
      itemType="https://schema.org/WebPage"
      itemProp="url"
      data-url={to}
      {...props}
    >
      {children}
    </div>
  );
};

export default RedirectLink;
